import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { createPageDraft } from './infra/repository/CreatePageDraft';

export default function StartPageDraft() {
  const { pageId } = useParams();
  const navigate = useNavigate();
  const fresh = new URLSearchParams(useLocation().search).get('fresh') === 'true';
  const operation = useRef(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    if (operation.current?.pageId !== pageId || operation.current?.fresh !== fresh) operation.current = { pageId, fresh, promise: createPageDraft(pageId, fresh) };
    operation.current.promise.then(draft => { if (active) return navigate(`/draft?draftId=${draft.id}`, { replace: true }); })
      .catch(() => { if (active) setError('Unable to open a page draft. Please try again.'); });
    return () => { active = false; };
  }, [pageId, fresh, navigate]);
  return <main className="course">{error ? <p role="alert">{error}</p> : <p><output>Opening page draft…</output></p>}<Link to="/courses">Back to courses</Link></main>;
}
